//styles/GlobalStyles.css

import './reset.css';
import './utilities.css';
import './theme.js';

const GlobalStyles = () => {
  return null;
};

export default GlobalStyles;